export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-6 border-b border-slate-200">
      <div>
        {eyebrow && (
          <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#D95A40] mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-black tracking-tighter text-3xl md:text-4xl text-[#0B1B3D]">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-slate-600 mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
